(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5683],{

/***/ 66193:
/***/ (function(module) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),

/***/ 93239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),

/***/ 711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEvery = __webpack_require__(66193),
    baseEvery = __webpack_require__(93239),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469),
    isIterateeCall = __webpack_require__(16612);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),

/***/ 73955:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(79833);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),

/***/ 92562:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ifo",
      function () {
        return __webpack_require__(41925);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Step; }
/* harmony export */ });
/* unused harmony export StepNumber */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var _Box_Flex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75943);
/* harmony import */ var _Box_Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    justify-content: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  width: 4px;\n  height: calc(50% + 20px);\n  ",
        "\n  left: calc(50% - 2px);\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    visibility: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  ",
        " {\n    display: block;\n    margin-right: 16px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 8px;\n  ",
        " {\n    margin-left: 16px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  box-shadow: 0px 1px 4px rgba(25, 19, 38, 0.15);\n  background-color: ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 600;\n  font-size: 32px;\n  width: 48px;\n  height: 48px;\n  z-index: 5;\n  ",
        " {\n    font-size: 40px;\n    width: 80px;\n    height: 80px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var getStepNumberFontColor = function getStepNumberFontColor(param) {
    var theme = param.theme, status = param.status;
    if (status === "past") {
        return theme.colors.success;
    }
    if (status === "current") {
        return theme.colors.invertedContrast;
    }
    return theme.colors.textDisabled;
};
var StyledStep = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Box_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d478b30a-0"
}).withConfig({
    componentId: "sc-c17a205b-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var Connector = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d478b30a-1"
}).withConfig({
    componentId: "sc-c17a205b-1"
})(_templateObject1(), function(param) {
    var $isFirstStep = param.$isFirstStep, $isLastStep = param.$isLastStep, $isFirstPart = param.$isFirstPart;
    if ($isFirstStep) return "top: 50%;";
    if ($isLastStep) return "top: 0;";
    return $isFirstPart ? "top:0;" : "top:50%;";
}, function(param) {
    var theme = param.theme, status = param.status;
    return theme.colors[status === "past" || status === "current" ? "success" : "textDisabled"];
});
var ChildrenWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Box_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d478b30a-2"
}).withConfig({
    componentId: "sc-c17a205b-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "visible" : "hidden";
});
var ChildrenLeftWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ChildrenWrapper).withConfig({
    componentId: "sc-d478b30a-3"
}).withConfig({
    componentId: "sc-c17a205b-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var ChildrenRightWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ChildrenWrapper).withConfig({
    componentId: "sc-d478b30a-4"
}).withConfig({
    componentId: "sc-c17a205b-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d478b30a-5"
}).withConfig({
    componentId: "sc-c17a205b-5"
})(_templateObject5());
var StepNumber = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d478b30a-6"
}).withConfig({
    componentId: "sc-c17a205b-6"
})(_templateObject6(), function(param) {
    var theme = param.theme, status = param.status;
    return theme.colors[status === "current" ? "secondary" : "invertedContrast"];
}, function(param) {
    var theme = param.theme, status = param.status;
    return status === "past" ? theme.colors.success : "transparent";
}, function(param) {
    var theme = param.theme;
    return theme.radii.circle;
}, getStepNumberFontColor, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
/**
 * ChildrenLeftWrapper and ChildrenRightWrapper are used on the non mobile version, to force the alternate layout.
 * One of the child is hidden based on the step number.
 */ var Step = function Step(param) {
    var index = param.index, statusFirstPart = param.statusFirstPart, statusSecondPart = param.statusSecondPart, _numberOfSteps = param.numberOfSteps, numberOfSteps = _numberOfSteps === void 0 ? 0 : _numberOfSteps, children = param.children;
    var isIndexPair = index % 2 === 0;
    var isFirst = index === 0;
    var isLast = index === numberOfSteps - 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledStep, {
        mb: index < numberOfSteps - 1 ? "16px" : 0,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChildrenLeftWrapper, {
                isVisible: !isIndexPair,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StepNumber, {
                        status: statusFirstPart,
                        children: index + 1
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Connector, {
                        $isFirstStep: isFirst,
                        $isLastStep: isLast,
                        status: statusFirstPart,
                        $isFirstPart: true
                    }),
                    !isFirst && !isLast && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Connector, {
                        $isFirstStep: isFirst,
                        $isLastStep: isLast,
                        status: statusSecondPart
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChildrenRightWrapper, {
                isVisible: isIndexPair,
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 6999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: fit-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StepperWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aff90cdd-0"
}).withConfig({
    componentId: "sc-54d67177-0"
})(_templateObject());
var Stepper = function Stepper(param) {
    var children = param.children;
    var numberOfSteps = react__WEBPACK_IMPORTED_MODULE_2__.Children.count(children);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StepperWrapper, {
        children: react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child) {
            if (/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.isValidElement(child)) {
                return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.cloneElement(child, {
                    numberOfSteps: numberOfSteps
                });
            }
            return child;
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Stepper);


/***/ }),

/***/ 95122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56063);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52775);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  button {\n    align-items: center;\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  height: ",
        ";\n  padding-bottom: ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8285e73f-0"
})(_templateObject());
var StyledExpandableLabelWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8285e73f-1"
})(_templateObject1());
var StyledChildrenFlex = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8285e73f-2"
})(_templateObject2(), function(param) {
    var isExpanded = param.isExpanded;
    return isExpanded ? "100%" : "0px";
}, function(param) {
    var isExpanded = param.isExpanded;
    return isExpanded ? "16px" : "0px";
}, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
});
var FoldableText = function(_param) {
    var title = _param.title, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "title",
        "children"
    ]);
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
                justifyContent: "space-between",
                alignItems: "center",
                pb: "16px",
                onClick: function() {
                    return setIsExpanded(function(s) {
                        return !s;
                    });
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        fontWeight: "bold",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledExpandableLabelWrapper, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* .ExpandableLabel */ .L, {
                            expanded: isExpanded,
                            children: isExpanded ? t("Hide") : t("Details")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledChildrenFlex, {
                isExpanded: isExpanded,
                flexDirection: "column",
                children: children
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FoldableText);


/***/ }),

/***/ 41925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ifo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/views/Ifos/index.tsx + 1 modules
var Ifos = __webpack_require__(79637);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(42918);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/views/Ifos/hooks/v3/useGetPublicIfoData.ts
var useGetPublicIfoData = __webpack_require__(50258);
// EXTERNAL MODULE: ./src/views/Ifos/hooks/v3/useGetWalletIfoData.ts
var useGetWalletIfoData = __webpack_require__(47228);
// EXTERNAL MODULE: ./src/views/Ifos/components/IfoFoldableCard/index.tsx + 4 modules
var IfoFoldableCard = __webpack_require__(64468);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(52775);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(40735);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(44305);
// EXTERNAL MODULE: ./src/views/Ifos/components/IfoLayout.tsx
var IfoLayout = __webpack_require__(80099);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(34701);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./src/views/Pools/components/CakeVaultCard/index.tsx + 10 modules
var CakeVaultCard = __webpack_require__(37593);
// EXTERNAL MODULE: ./src/state/pools/hooks.ts + 1 modules
var hooks = __webpack_require__(83251);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var wagmi_src = __webpack_require__(29315);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(20353);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardHeader.tsx
var CardHeader = __webpack_require__(55209);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/TokenPairImage.tsx + 2 modules
var TokenPairImage = __webpack_require__(41768);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/ExpandableButton.tsx
var ExpandableButton = __webpack_require__(56063);
// EXTERNAL MODULE: ./src/components/Balance.tsx
var Balance = __webpack_require__(18778);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(62712);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(96470);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./src/views/Ifos/contexts/IfoContext.tsx
var IfoContext = __webpack_require__(95092);
;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoPoolVaultCardMobile.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 400px;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    line-height: 1.2;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var StyledCardMobile = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-59cdf738-0"
})(_templateObject());
var StyledTokenContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-59cdf738-1"
})(_templateObject1(), Text/* default */.Z);
var IfoPoolVaultCardMobile = function(param) {
    var pool = param.pool;
    var t = (0,src/* useTranslation */.$G)().t;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var credit = (0,hooks/* useIfoCredit */.cq)();
    var ref = (0,IfoContext/* useConfig */.ZR)(), isExpanded = ref.isExpanded, setIsExpanded = ref.setIsExpanded;
    var cakeAsNumberBalance = (0,formatBalance/* getBalanceNumber */.mW)(credit);
    var vaultPool = (0,hooks/* useVaultPoolByKey */.eB)(pool.vaultKey);
    var _userData = vaultPool.userData, userShares = _userData.userShares, isVaultUserDataLoading = _userData.isLoading, performanceFeeAsDecimal = vaultPool.fees.performanceFeeAsDecimal;
    var accountHasSharesStaked = userShares && userShares.gt(0);
    var isLoading = !pool.userData || isVaultUserDataLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardMobile, {
        isActive: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                p: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTokenContent, {
                            alignItems: "center",
                            flex: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenPairImage/* default */.Z, (0,_object_spread/* default */.Z)({
                                    width: 24,
                                    height: 24
                                }, pools/* vaultPoolConfig */.Y4[types/* VaultKey.CakeVault */.om.CakeVault].tokenImage)),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    ml: "8px",
                                    width: "180px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            small: true,
                                            bold: true,
                                            children: pools/* vaultPoolConfig */.Y4[types/* VaultKey.CakeVault */.om.CakeVault].name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "textSubtle",
                                            fontSize: "12px",
                                            children: pools/* vaultPoolConfig */.Y4[types/* VaultKey.CakeVault */.om.CakeVault].description
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTokenContent, {
                            flexDirection: "column",
                            flex: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "textSubtle",
                                    fontSize: "12px",
                                    children: t("iSHDW")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                    small: true,
                                    bold: true,
                                    decimals: 3,
                                    value: cakeAsNumberBalance
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableButton/* ExpandableButton */.N, {
                            expanded: isExpanded,
                            onClick: function() {
                                return setIsExpanded(function(prev) {
                                    return !prev;
                                });
                            }
                        })
                    ]
                })
            }),
            isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard/* CakeVaultDetail */._, {
                showICake: true,
                isLoading: isLoading,
                account: account,
                pool: pool,
                vaultPool: vaultPool,
                accountHasSharesStaked: accountHasSharesStaked,
                performanceFeeAsDecimal: performanceFeeAsDecimal
            })
        ]
    });
};
/* harmony default export */ var components_IfoPoolVaultCardMobile = (IfoPoolVaultCardMobile);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/components/Trans.tsx
var Trans = __webpack_require__(4369);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(70257);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/Image.tsx
var Image = __webpack_require__(63970);
;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoVesting/types.ts
var VestingStatus;
(function(VestingStatus) {
    VestingStatus["NOT_TOKENS_CLAIM"] = "NOT_TOKENS_CLAIM";
    VestingStatus["HAS_TOKENS_CLAIM"] = "HAS_TOKENS_CLAIM";
    VestingStatus["ENDED"] = "ENDED";
})(VestingStatus || (VestingStatus = {}));

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/BunnyPlaceholder.tsx
var BunnyPlaceholder = __webpack_require__(55787);
// EXTERNAL MODULE: ./src/views/Ifos/components/IfoCardStyles.tsx
var IfoCardStyles = __webpack_require__(35206);
;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoVesting/NotTokens.tsx




var NotTokens = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BunnyPlaceholder/* default */.Z, {
                width: 80,
                height: 80,
                margin: "auto"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                alignItems: "center",
                mt: "16px",
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        mb: "8px",
                        textAlign: "center",
                        children: t("You have no tokens available for claiming")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: "textSubtle",
                        textAlign: "center",
                        children: t("Participate in our next IFO. and remember to lock your SHDW to increase your allocation!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(IfoCardStyles/* MessageTextLink */.Ne, {
                        href: "/ifo#ifo-how-to",
                        color: "primary",
                        display: "inline",
                        children: [
                            t("How does it work?"),
                            " \xbb"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var IfoVesting_NotTokens = (NotTokens);

// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/hooks/useDelayedUnmount.ts
var useDelayedUnmount = __webpack_require__(42219);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(57049);
// EXTERNAL MODULE: ./src/components/TokenImage/index.tsx
var TokenImage = __webpack_require__(39023);
// EXTERNAL MODULE: ./src/config/constants/types.ts
var constants_types = __webpack_require__(75759);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(2629);
// EXTERNAL MODULE: ./src/utils/prices.ts
var prices = __webpack_require__(98045);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./packages/uikit/src/components/Tag/Tag.tsx + 3 modules
var Tag = __webpack_require__(22769);
// EXTERNAL MODULE: ./packages/uikit/src/components/Progress/Progress.tsx + 1 modules
var Progress = __webpack_require__(79207);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(19237);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(63771);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 1 modules
var Toast = __webpack_require__(96036);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(76431);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(36963);
;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoVesting/VestingPeriod/Claim.tsx









var ClaimButton = function(param) {
    var poolId = param.poolId, data = param.data, claimableAmount = param.claimableAmount, fetchUserVestingData = param.fetchUserVestingData;
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var _ifo = data.ifo, address = _ifo.address, token = _ifo.token;
    var contract = (0,useContract/* useIfoV3Contract */.Dm)(address);
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, isPending = ref.loading;
    var handleClaim = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var vestingId, receipt;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    vestingId = data.userVestingData[poolId].vestingId;
                    _ctx.next = 3;
                    return fetchWithCatchTxError(function() {
                        return contract.release(vestingId);
                    });
                case 3:
                    receipt = _ctx.sent;
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Success!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash,
                            children: t("You have successfully claimed available tokens.")
                        }));
                        fetchUserVestingData();
                    }
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        data,
        poolId,
        contract,
        t,
        fetchUserVestingData,
        fetchWithCatchTxError,
        toastSuccess
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        mt: "20px",
        width: "100%",
        onClick: handleClaim,
        isLoading: isPending,
        disabled: isPending || claimableAmount === "0",
        endIcon: isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "currentColor"
        }) : null,
        children: t("Claim %symbol%", {
            symbol: token.symbol
        })
    });
};
/* harmony default export */ var Claim = (ClaimButton);

;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoVesting/VestingPeriod/Info.tsx

function Info_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 12px;\n  border-radius: 12px;\n  margin: 8px 0 20px 0;\n"
    ]);
    Info_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Info_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  color: ",
        ";\n  background: ",
        ";\n"
    ]);
    Info_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var WhiteCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-99aa096f-0"
})(Info_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var StyleTag = (0,styled_components_browser_esm/* default */.ZP)(Tag/* default */.Z).withConfig({
    componentId: "sc-99aa096f-1"
})(Info_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme, isPrivate = param.isPrivate;
    return isPrivate ? theme.colors.gradientBlue : theme.colors.gradientViolet;
});
var Info = function(param) {
    var poolId = param.poolId, data = param.data, fetchUserVestingData = param.fetchUserVestingData;
    var t = (0,src/* useTranslation */.$G)().t;
    var token = data.ifo.token;
    var _poolId = data.userVestingData[poolId], vestingComputeReleasableAmount = _poolId.vestingComputeReleasableAmount, offeringAmountInToken = _poolId.offeringAmountInToken, vestingInformationPercentage = _poolId.vestingInformationPercentage, vestingReleased = _poolId.vestingReleased;
    var labelText = poolId === constants_types/* PoolIds.poolUnlimited */.vr.poolUnlimited ? t("Public Sale") : t("Private Sale");
    var vestingPercentage = (0,react.useMemo)(function() {
        return new (bignumber_default())(vestingInformationPercentage).times(0.01);
    }, [
        vestingInformationPercentage
    ]);
    var releasedAtSaleEnd = (0,react.useMemo)(function() {
        return new (bignumber_default())(offeringAmountInToken).times(new (bignumber_default())(1).minus(vestingPercentage));
    }, [
        offeringAmountInToken,
        vestingPercentage
    ]);
    var amountReleased = (0,react.useMemo)(function() {
        return new (bignumber_default())(releasedAtSaleEnd).plus(vestingReleased).plus(vestingComputeReleasableAmount);
    }, [
        releasedAtSaleEnd,
        vestingReleased,
        vestingComputeReleasableAmount
    ]);
    var received = (0,react.useMemo)(function() {
        var alreadyClaimed = new (bignumber_default())(releasedAtSaleEnd).plus(vestingReleased);
        return alreadyClaimed.gt(0) ? (0,formatBalance/* getFullDisplayBalance */.NJ)(alreadyClaimed, token.decimals, 4) : "0";
    }, [
        token,
        releasedAtSaleEnd,
        vestingReleased
    ]);
    var claimable = (0,react.useMemo)(function() {
        return vestingComputeReleasableAmount.gt(0) ? (0,formatBalance/* getFullDisplayBalance */.NJ)(vestingComputeReleasableAmount, token.decimals, 4) : "0";
    }, [
        token,
        vestingComputeReleasableAmount
    ]);
    var remaining = (0,react.useMemo)(function() {
        var remain = new (bignumber_default())(offeringAmountInToken).minus(amountReleased);
        return remain.gt(0) ? (0,formatBalance/* getFullDisplayBalance */.NJ)(remain, token.decimals, 4) : "0";
    }, [
        token,
        offeringAmountInToken,
        amountReleased
    ]);
    var percentage = (0,react.useMemo)(function() {
        var total = new (bignumber_default())(received).plus(claimable).plus(remaining);
        var receivedPercentage = new (bignumber_default())(received).div(total).times(100).toNumber();
        var amountAvailablePercentage = new (bignumber_default())(claimable).div(total).times(100).toNumber();
        return {
            receivedPercentage: receivedPercentage,
            amountAvailablePercentage: receivedPercentage + amountAvailablePercentage
        };
    }, [
        received,
        claimable,
        remaining
    ]);
    if (claimable === "0" && remaining === "0") {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        style: {
                            alignSelf: "center"
                        },
                        fontSize: "12px",
                        bold: true,
                        color: "secondary",
                        textTransform: "uppercase",
                        children: t("Vesting Schedule")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleTag, {
                        isPrivate: poolId === constants_types/* PoolIds.poolBasic */.vr.poolBasic,
                        children: labelText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhiteCard, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* default */.Z, {
                        primaryStep: percentage.receivedPercentage,
                        secondaryStep: percentage.amountAvailablePercentage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "column",
                                mr: "8px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: received
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        color: "textSubtle",
                                        children: t("Received")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: claimable
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        color: "textSubtle",
                                        children: t("Claimable")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "column",
                                ml: "auto",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        textAlign: "right",
                                        children: remaining
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        color: "textSubtle",
                                        children: t("Remaining")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Claim, {
                        poolId: poolId,
                        data: data,
                        claimableAmount: claimable,
                        fetchUserVestingData: fetchUserVestingData
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var VestingPeriod_Info = (Info);

;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoVesting/VestingPeriod/Expand.tsx

function Expand_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    opacity: 0;\n    max-height: 0px;\n  }\n  to {\n    opacity: 1;\n    max-height: 484px;\n  }\n"
    ]);
    Expand_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Expand_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    opacity: 1;\n    max-height: 484px;\n  }\n  to {\n    opacity: 0;\n    max-height: 0px;\n  }\n"
    ]);
    Expand_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        " 300ms linear forwards\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        " 300ms linear forwards\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 0;\n  opacity: 1;\n  animation: ",
        ";\n  overflow: hidden;\n  margin: 0 -24px;\n  padding: 24px;\n  background: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var expandAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(Expand_templateObject());
var collapseAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(Expand_templateObject1());
var StyledExpand = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-dac909db-0"
})(_templateObject4(), function(param) {
    var expanded = param.expanded;
    return expanded ? (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), expandAnimation) : (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), collapseAnimation);
}, function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
});
var Expand = function(param) {
    var data = param.data, expanded = param.expanded, fetchUserVestingData = param.fetchUserVestingData;
    var t = (0,src/* useTranslation */.$G)().t;
    var token = data.ifo.token;
    var router = (0,next_router.useRouter)();
    var handleViewIfo = function() {
        router.push("/ifo/history#".concat(token.symbol));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledExpand, {
        expanded: expanded,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VestingPeriod_Info, {
                poolId: constants_types/* PoolIds.poolUnlimited */.vr.poolUnlimited,
                data: data,
                fetchUserVestingData: fetchUserVestingData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VestingPeriod_Info, {
                poolId: constants_types/* PoolIds.poolBasic */.vr.poolBasic,
                data: data,
                fetchUserVestingData: fetchUserVestingData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                color: "primary",
                textAlign: "center",
                style: {
                    cursor: "pointer"
                },
                onClick: handleViewIfo,
                children: t("View IFO")
            })
        ]
    });
};
/* harmony default export */ var VestingPeriod_Expand = (Expand);

;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoVesting/VestingPeriod/TokenInfo.tsx

function TokenInfo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: ",
        ";\n  height: 24px;\n"
    ]);
    TokenInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var ArrowIcon = (0,styled_components_browser_esm/* default */.ZP)(ChevronDown/* default */.Z).withConfig({
    componentId: "sc-b2dcf810-0"
})(TokenInfo_templateObject(), function(param) {
    var toggled = param.toggled;
    return toggled ? "rotate(180deg)" : "rotate(0)";
});
var TokenInfo = function(param) {
    var index = param.index, data = param.data, fetchUserVestingData = param.fetchUserVestingData;
    var _ifo = data.ifo, vestingTitle = _ifo.vestingTitle, token = _ifo.token;
    var vestingComputeReleasableAmount = data.userVestingData[constants_types/* PoolIds.poolUnlimited */.vr.poolUnlimited].vestingComputeReleasableAmount;
    var _poolBasic = data.userVestingData[constants_types/* PoolIds.poolBasic */.vr.poolBasic], basicReleaseAmount = _poolBasic.vestingComputeReleasableAmount;
    var ref = (0,react.useState)(false), expanded = ref[0], setExpanded = ref[1];
    var shouldRenderExpand = (0,useDelayedUnmount/* default */.Z)(expanded, 300);
    (0,react.useEffect)(function() {
        if (index === 0) {
            setExpanded(true);
        }
    }, [
        index
    ]);
    var toggleExpanded = function() {
        setExpanded(function(prev) {
            return !prev;
        });
    };
    var amountAvailable = (0,react.useMemo)(function() {
        var totalReleaseAmount = new (bignumber_default())(vestingComputeReleasableAmount).plus(basicReleaseAmount);
        return (0,formatBalance/* getBalanceNumber */.mW)(totalReleaseAmount, token.decimals);
    }, [
        token,
        vestingComputeReleasableAmount,
        basicReleaseAmount
    ]);
    var price = (0,useBUSDPrice/* default */.ZP)(token);
    var dollarValueOfToken = (0,prices/* multiplyPriceByAmount */.a)(price, amountAvailable, token.decimals);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                p: "24px",
                m: "-24px -24px 0 -24px",
                style: {
                    cursor: "pointer"
                },
                onClick: toggleExpanded,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenImage/* TokenImage */.O, {
                        width: 32,
                        height: 32,
                        token: token
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        ml: "8px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                lineHeight: "120%",
                                children: vestingTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                                        color: "secondary",
                                        value: amountAvailable,
                                        decimals: 4,
                                        bold: true,
                                        fontSize: "12px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        color: "textSubtle",
                                        textTransform: "uppercase",
                                        fontSize: "12px",
                                        margin: "0 2px",
                                        children: [
                                            token.symbol,
                                            " ~$",
                                            dollarValueOfToken.toFixed(2)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                        toggled: expanded,
                        color: "primary",
                        ml: "auto"
                    })
                ]
            }),
            shouldRenderExpand && /*#__PURE__*/ (0,jsx_runtime.jsx)(VestingPeriod_Expand, {
                expanded: expanded,
                data: data,
                fetchUserVestingData: fetchUserVestingData
            })
        ]
    });
};
/* harmony default export */ var VestingPeriod_TokenInfo = (TokenInfo);

;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoVesting/VestingEnded.tsx



var VestingEnded = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        color: "textSubtle",
        fontSize: "14px",
        pb: "24px",
        children: t("You have claimed all available token.")
    });
};
/* harmony default export */ var IfoVesting_VestingEnded = (VestingEnded);

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(87318);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(9796);
// EXTERNAL MODULE: ./src/config/abi/ifoV3.json
var ifoV3 = __webpack_require__(49795);
;// CONCATENATED MODULE: ./src/views/Ifos/hooks/vesting/fetchUserWalletIfoData.ts











var fetchUserWalletIfoData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(ifo, account) {
        var address, userVestingData, ref, ref1, basicId, ref2, unlimitedId, ifov3Calls, ref3, amounts, basicSchedule, unlimitedSchedule, basicReleasableAmount, unlimitedReleasableAmount, basicVestingInformation, unlimitedVestingInformation, vestingStartTime, _obj;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    address = ifo.address;
                    userVestingData = {
                        vestingStartTime: 0,
                        poolBasic: {
                            vestingId: "0",
                            offeringAmountInToken: bigNumber/* BIG_ZERO */.HW,
                            vestingReleased: bigNumber/* BIG_ZERO */.HW,
                            vestingAmountTotal: bigNumber/* BIG_ZERO */.HW,
                            vestingComputeReleasableAmount: bigNumber/* BIG_ZERO */.HW,
                            vestingInformationPercentage: 0,
                            vestingInformationDuration: 0
                        },
                        poolUnlimited: {
                            vestingId: "0",
                            offeringAmountInToken: bigNumber/* BIG_ZERO */.HW,
                            vestingReleased: bigNumber/* BIG_ZERO */.HW,
                            vestingAmountTotal: bigNumber/* BIG_ZERO */.HW,
                            vestingComputeReleasableAmount: bigNumber/* BIG_ZERO */.HW,
                            vestingInformationPercentage: 0,
                            vestingInformationDuration: 0
                        }
                    };
                    if (!account) {
                        _ctx.next = 28;
                        break;
                    }
                    _ctx.t0 = _sliced_to_array/* default */.Z;
                    _ctx.next = 6;
                    return (0,multicall/* multicallv2 */.v)({
                        abi: ifoV3,
                        calls: [
                            {
                                address: address,
                                name: "computeVestingScheduleIdForAddressAndPid",
                                params: [
                                    account,
                                    0
                                ]
                            },
                            {
                                address: address,
                                name: "computeVestingScheduleIdForAddressAndPid",
                                params: [
                                    account,
                                    1
                                ]
                            }, 
                        ],
                        options: {
                            requireSuccess: false
                        }
                    });
                case 6:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 2);
                    ref1 = (0,_sliced_to_array/* default */.Z)(ref[0], 1);
                    basicId = ref1[0];
                    ref2 = (0,_sliced_to_array/* default */.Z)(ref[1], 1);
                    unlimitedId = ref2[0];
                    ifov3Calls = [
                        {
                            address: address,
                            name: "viewUserOfferingAndRefundingAmountsForPools",
                            params: [
                                account,
                                [
                                    0,
                                    1
                                ]
                            ]
                        },
                        {
                            address: address,
                            name: "getVestingSchedule",
                            params: [
                                basicId
                            ]
                        },
                        {
                            address: address,
                            name: "getVestingSchedule",
                            params: [
                                unlimitedId
                            ]
                        },
                        {
                            address: address,
                            name: "computeReleasableAmount",
                            params: [
                                basicId
                            ]
                        },
                        {
                            address: address,
                            name: "computeReleasableAmount",
                            params: [
                                unlimitedId
                            ]
                        },
                        {
                            address: address,
                            name: "viewPoolVestingInformation",
                            params: [
                                0
                            ]
                        },
                        {
                            address: address,
                            name: "viewPoolVestingInformation",
                            params: [
                                1
                            ]
                        },
                        {
                            address: address,
                            name: "vestingStartTime"
                        }, 
                    ];
                    _ctx.t2 = _sliced_to_array/* default */.Z;
                    _ctx.next = 16;
                    return (0,multicall/* multicallv2 */.v)({
                        abi: ifoV3,
                        calls: ifov3Calls,
                        options: {
                            requireSuccess: false
                        }
                    });
                case 16:
                    _ctx.t3 = _ctx.sent;
                    ref3 = (0, _ctx.t2)(_ctx.t3, 8);
                    amounts = ref3[0];
                    basicSchedule = ref3[1];
                    unlimitedSchedule = ref3[2];
                    basicReleasableAmount = ref3[3];
                    unlimitedReleasableAmount = ref3[4];
                    basicVestingInformation = ref3[5];
                    unlimitedVestingInformation = ref3[6];
                    vestingStartTime = ref3[7];
                    ;
                    userVestingData = (_obj = {
                        vestingStartTime: vestingStartTime ? vestingStartTime[0].toNumber() : 0
                    }, (0,_define_property/* default */.Z)(_obj, constants_types/* PoolIds.poolBasic */.vr.poolBasic, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, userVestingData[constants_types/* PoolIds.poolBasic */.vr.poolBasic]), {
                        vestingId: basicId ? basicId.toString() : "0",
                        offeringAmountInToken: new (bignumber_default())(amounts[0][0][0].toString()),
                        vestingReleased: basicSchedule ? new (bignumber_default())(basicSchedule[0].released.toString()) : bigNumber/* BIG_ZERO */.HW,
                        vestingAmountTotal: basicSchedule ? new (bignumber_default())(basicSchedule[0].amountTotal.toString()) : bigNumber/* BIG_ZERO */.HW,
                        vestingComputeReleasableAmount: basicReleasableAmount ? new (bignumber_default())(basicReleasableAmount.toString()) : bigNumber/* BIG_ZERO */.HW,
                        vestingInformationPercentage: basicVestingInformation ? basicVestingInformation[0].toNumber() : 0,
                        vestingInformationDuration: basicVestingInformation ? basicVestingInformation[2].toNumber() : 0
                    })), (0,_define_property/* default */.Z)(_obj, constants_types/* PoolIds.poolUnlimited */.vr.poolUnlimited, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, userVestingData[constants_types/* PoolIds.poolUnlimited */.vr.poolUnlimited]), {
                        vestingId: unlimitedId ? unlimitedId.toString() : "0",
                        offeringAmountInToken: new (bignumber_default())(amounts[0][1][0].toString()),
                        vestingReleased: unlimitedSchedule ? new (bignumber_default())(unlimitedSchedule[0].released.toString()) : bigNumber/* BIG_ZERO */.HW,
                        vestingAmountTotal: unlimitedSchedule ? new (bignumber_default())(unlimitedSchedule[0].amountTotal.toString()) : bigNumber/* BIG_ZERO */.HW,
                        vestingComputeReleasableAmount: unlimitedReleasableAmount ? new (bignumber_default())(unlimitedReleasableAmount.toString()) : bigNumber/* BIG_ZERO */.HW,
                        vestingInformationPercentage: unlimitedVestingInformation ? unlimitedVestingInformation[0].toNumber() : 0,
                        vestingInformationDuration: unlimitedVestingInformation ? unlimitedVestingInformation[2].toNumber() : 0
                    })), _obj);
                case 28:
                    return _ctx.abrupt("return", {
                        ifo: ifo,
                        userVestingData: userVestingData
                    });
                case 29:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchUserWalletIfoData(ifo, account) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/views/Ifos/hooks/vesting/useFetchVestingData.ts








var allVestingIfo = constants/* ifosConfig.filter */.Q2.filter(function(ifo) {
    return ifo.version >= 3.2 && ifo.vestingTitle;
});
var useFetchVestingData = function() {
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var ref = (0,dist/* default */.ZP)(account ? [
        "vestingData"
    ] : null, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var allData;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return Promise.all(allVestingIfo.map(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(ifo) {
                            var response;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.next = 2;
                                        return fetchUserWalletIfoData(ifo, account);
                                    case 2:
                                        response = _ctx.sent;
                                        return _ctx.abrupt("return", response);
                                    case 4:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(ifo) {
                            return _ref.apply(this, arguments);
                        };
                    }()));
                case 2:
                    allData = _ctx.sent;
                    return _ctx.abrupt("return", allData.filter(// eslint-disable-next-line array-callback-return, consistent-return
                    function(ifo) {
                        var userVestingData = ifo.userVestingData;
                        var currentTimeStamp = new Date().getTime();
                        var vestingStartTime = new (bignumber_default())(userVestingData.vestingStartTime);
                        var isPoolUnlimitedLive = vestingStartTime.plus(userVestingData[constants_types/* PoolIds.poolUnlimited */.vr.poolUnlimited].vestingInformationDuration).times(1000).gte(currentTimeStamp);
                        var isPoolBasicLive = vestingStartTime.plus(userVestingData[constants_types/* PoolIds.poolBasic */.vr.poolBasic].vestingInformationDuration).times(1000).gte(currentTimeStamp);
                        if ((userVestingData[constants_types/* PoolIds.poolBasic */.vr.poolBasic].offeringAmountInToken.gt(0) || userVestingData[constants_types/* PoolIds.poolUnlimited */.vr.poolUnlimited].offeringAmountInToken.gt(0)) && (userVestingData[constants_types/* PoolIds.poolBasic */.vr.poolBasic].vestingComputeReleasableAmount.gt(0) || userVestingData[constants_types/* PoolIds.poolUnlimited */.vr.poolUnlimited].vestingComputeReleasableAmount.gt(0) || isPoolBasicLive || isPoolUnlimitedLive)) {
                            return ifo;
                        }
                    }));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        revalidateOnFocus: false,
        refreshInterval: constants/* FAST_INTERVAL */.sR,
        dedupingInterval: constants/* FAST_INTERVAL */.sR
    }), data = ref.data, mutate = ref.mutate;
    return {
        data: data || [],
        fetchUserVestingData: mutate
    };
};
/* harmony default export */ var vesting_useFetchVestingData = (useFetchVestingData);

;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoVesting/index.tsx


function IfoVesting_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 400px;\n  margin: 24px 0 0 0;\n  align-self: baseline;\n  ",
        " {\n    max-width: 350px;\n    margin: -22px 12px 0 12px;\n  }\n"
    ]);
    IfoVesting_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IfoVesting_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 2;\n  overflow-y: auto;\n  max-height: 570px;\n  padding-bottom: 0;\n  border-radius: 0 0 24px 24px;\n"
    ]);
    IfoVesting_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function IfoVesting_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > div {\n    margin-bottom: 20px;\n  }\n\n  > :last-child {\n    margin-bottom: 0px;\n  }\n"
    ]);
    IfoVesting_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var StyleVestingCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-6245cd13-0"
})(IfoVesting_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
var VestingCardBody = (0,styled_components_browser_esm/* default */.ZP)(CardBody/* default */.Z).withConfig({
    componentId: "sc-6245cd13-1"
})(IfoVesting_templateObject1());
var TokenInfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6245cd13-2"
})(IfoVesting_templateObject2());
var _obj;
var IfoVestingStatus = (_obj = {}, (0,_define_property/* default */.Z)(_obj, VestingStatus.NOT_TOKENS_CLAIM, {
    status: VestingStatus.NOT_TOKENS_CLAIM,
    text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
        children: "You have no tokens available for claiming"
    }),
    imgUrl: "/images/ifos/vesting/not-tokens.svg"
}), (0,_define_property/* default */.Z)(_obj, VestingStatus.HAS_TOKENS_CLAIM, {
    status: VestingStatus.HAS_TOKENS_CLAIM,
    text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
        children: "You have tokens available for claiming now!"
    }),
    imgUrl: "/images/ifos/vesting/in-vesting-period.svg"
}), (0,_define_property/* default */.Z)(_obj, VestingStatus.ENDED, {
    status: VestingStatus.ENDED,
    text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
        children: "No vesting token to claim."
    }),
    imgUrl: "/images/ifos/vesting/in-vesting-end.svg"
}), _obj);
var IfoVesting = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var ref = (0,react.useState)(true), isFirstTime = ref[0], setIsFirstTime = ref[1];
    var ref1 = vesting_useFetchVestingData(), data = ref1.data, fetchUserVestingData = ref1.fetchUserVestingData;
    (0,react.useEffect)(function() {
        // When switch account need init
        if (account) {
            setIsFirstTime(true);
            fetchUserVestingData();
        }
    }, [
        account,
        fetchUserVestingData,
        setIsFirstTime
    ]);
    var cardStatus = (0,react.useMemo)(function() {
        if (account) {
            if (data.length > 0) return IfoVestingStatus[VestingStatus.HAS_TOKENS_CLAIM];
            if (data.length === 0 && !isFirstTime) return IfoVestingStatus[VestingStatus.ENDED];
        }
        return IfoVestingStatus[VestingStatus.NOT_TOKENS_CLAIM];
    }, [
        data,
        account,
        isFirstTime
    ]);
    var handleFetchUserVesting = (0,react.useCallback)(function() {
        setIsFirstTime(false);
        fetchUserVestingData();
    }, [
        fetchUserVestingData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyleVestingCard, {
        isActive: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                p: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            ml: "8px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "24px",
                                    color: "secondary",
                                    bold: true,
                                    children: t("Token Vesting")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "textSubtle",
                                    fontSize: "14px",
                                    children: cardStatus.text
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            ml: "8px",
                            width: 64,
                            height: 64,
                            alt: "ifo-vesting-status",
                            style: {
                                minWidth: "64px"
                            },
                            src: cardStatus.imgUrl
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VestingCardBody, {
                children: [
                    cardStatus.status === VestingStatus.NOT_TOKENS_CLAIM && /*#__PURE__*/ (0,jsx_runtime.jsx)(IfoVesting_NotTokens, {}),
                    cardStatus.status === VestingStatus.HAS_TOKENS_CLAIM && /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenInfoContainer, {
                        children: data.map(function(ifo, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VestingPeriod_TokenInfo, {
                                index: index,
                                data: ifo,
                                fetchUserVestingData: handleFetchUserVesting
                            }, ifo.ifo.id);
                        })
                    }),
                    cardStatus.status === VestingStatus.ENDED && /*#__PURE__*/ (0,jsx_runtime.jsx)(IfoVesting_VestingEnded, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var components_IfoVesting = (IfoVesting);

;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoPoolVaultCard.tsx







var IfoPoolVaultCard = function() {
    var ref = (0,useMatchBreakpoints/* default */.Z)(), isXl = ref.isXl, isLg = ref.isLg, isMd = ref.isMd, isXs = ref.isXs, isSm = ref.isSm;
    var isSmallerThanXl = isXl || isLg || isMd || isXs || isSm;
    var pools = (0,hooks/* usePoolsWithVault */.f6)().pools;
    var cakePool = (0,react.useMemo)(function() {
        return pools.find(function(pool) {
            return pool.userData && pool.sousId === 0;
        });
    }, [
        pools
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        maxWidth: 400,
        alignItems: "center",
        flexDirection: "column",
        children: [
            isSmallerThanXl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IfoPoolVaultCardMobile, {
                pool: cakePool
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard/* default */.Z, {
                pool: cakePool,
                showStakedOnly: false,
                showICake: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IfoVesting, {
                pool: cakePool
            })
        ]
    });
};
/* harmony default export */ var components_IfoPoolVaultCard = (IfoPoolVaultCard);

// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(69589);
// EXTERNAL MODULE: ./src/components/FoldableSection/FoldableText.tsx
var FoldableText = __webpack_require__(95122);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(98768);
;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoQuestions/config.tsx

function config_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n"
    ]);
    config_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var InlineLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-d9a68da9-0"
})(config_templateObject());
var config = [
    {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
            children: "What’s the difference between a Public Sale and Private Sale?"
        }),
        description: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                children: "In the current IFO format. There is a brand new Private Sale. To participate, participants will have to meet certain requirements presented on the IFO card. Each eligible participant will be able to commit any amount of SHDW up to the maximum commit limit, which is published along with the IFO voting proposal/Information. The Private Sale has no participation fee."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                children: "In the Public Sale, the maximum amount of WCORE users can commit, is equal to the number of iSHDW they have."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                        children: "Learn more about iSHDW"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineLink, {
                        ml: "4px",
                        external: true,
                        href: "https://shadow-11.gitbook.io/shadowswap/products/ifo-initial-farm-offering",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                            children: "here"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                children: "And there’s a fee for participation: see below."
            }), 
        ]
    },
    {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
            children: "Which sale should I commit to? Can I do both?"
        }),
        description: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                children: "You can choose one or both at the same time!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                children: "We recommend you to check if you are eligible to participate in the Private Sale first. In the Public Sale, if the amount you commit is too small, you may not receive a meaningful amount of IFO tokens."
            }), 
        ]
    },
    {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
            children: "How much is the participation fee?"
        }),
        description: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                children: "There’s only a participation fee for the Public Sale: there’s no fee for the Private Sale."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                children: "The participation fee decreases in cliffs, based on the percentage of overflow from the “Public Sale” portion of the IFO."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                children: "Note: Fees may vary between different IFOs. To learn more about the participation fees, please refer to the details in the IFO proposal (vote)/Information for the specifics of the IFO you want to take part in."
            }), 
        ]
    },
    {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
            children: "Where does the participation fee go?"
        }),
        description: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                children: "The SHDW from the participation fee will be burnt."
            })
        ]
    }, 
];
/* harmony default export */ var IfoQuestions_config = (config);

;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoQuestions/index.tsx
/* eslint-disable react/no-array-index-key */ 
function IfoQuestions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: none;\n  order: 2;\n  max-width: 414px;\n  width: 100%;\n\n  ",
        " {\n    order: 1;\n  }\n"
    ]);
    IfoQuestions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IfoQuestions_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  order: 1;\n  margin-bottom: 40px;\n\n  ",
        " {\n    order: 2;\n    margin-bottom: 0;\n    margin-left: 40px;\n  }\n"
    ]);
    IfoQuestions_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60abd119-0"
})(IfoQuestions_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var DetailsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60abd119-1"
})(IfoQuestions_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var IfoQuestions = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: [
            "center",
            null,
            null,
            "start"
        ],
        flexDirection: [
            "column",
            null,
            null,
            "row"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/images/ifos/Shadowswap_V3.gif",
                    alt: "ifo bunny",
                    width: 1000,
                    height: 1000
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                scale: "lg",
                                color: "secondary",
                                children: t("Details")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody/* default */.Z, {
                            children: IfoQuestions_config.map(function(param, i, param1) {
                                var title = param.title, description = param.description, length = param1.length;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FoldableText/* default */.Z, {
                                    mb: i + 1 === length ? "" : "24px",
                                    title: title,
                                    children: description.map(function(desc, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "textSubtle",
                                            as: "p",
                                            children: desc
                                        }, index);
                                    })
                                }, i);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_IfoQuestions = (IfoQuestions);

;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoContainer.tsx

function IfoContainer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n"
    ]);
    IfoContainer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var IfoStepBackground = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-e8013fe7-0"
})(IfoContainer_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gradientBubblegum;
});
var IfoContainer = function(param) {
    var ifoSection = param.ifoSection, ifoSteps = param.ifoSteps;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IfoLayout/* default */.Z, {
        id: "current-ifo",
        py: [
            "24px",
            "24px",
            "40px"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IfoLayout/* IfoLayoutWrapper */.d, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IfoPoolVaultCard, {}),
                        ifoSection
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IfoStepBackground, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: ifoSteps
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IfoQuestions, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                        href: "https://docs.google.com/forms/d/e/1FAIpQLSevsQylnWNYeYYA-JXd7j3DDxhuZV_HibW-iTSXt51JkualyA/viewform?vc=0&c=0&w=1&flr=0",
                        mx: "auto",
                        mt: "16px",
                        children: t("Apply to run an IFO!")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_IfoContainer = (IfoContainer);

// EXTERNAL MODULE: ./node_modules/lodash/every.js
var every = __webpack_require__(711);
var every_default = /*#__PURE__*/__webpack_require__.n(every);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(88896);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(94998);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/LogoRound.tsx
var LogoRound = __webpack_require__(24653);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(62685);
// EXTERNAL MODULE: ./packages/uikit/src/components/Stepper/Stepper.tsx
var Stepper = __webpack_require__(6999);
// EXTERNAL MODULE: ./packages/uikit/src/components/Stepper/Step.tsx
var Step = __webpack_require__(99018);
// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(12966);
// EXTERNAL MODULE: ./src/hooks/useTokenBalance.ts
var useTokenBalance = __webpack_require__(94186);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx + 1 modules
var ConnectWalletButton = __webpack_require__(72409);
// EXTERNAL MODULE: ./src/components/Layout/Flex.tsx
var Layout_Flex = __webpack_require__(44142);
// EXTERNAL MODULE: ./src/views/Pools/helpers.tsx
var helpers = __webpack_require__(87237);
;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoSteps.tsx

function IfoSteps_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 16px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    IfoSteps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IfoSteps_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: -16px;\n  margin-right: -16px;\n  padding-top: 48px;\n  padding-bottom: 48px;\n\n  ",
        " {\n    margin-left: -24px;\n    margin-right: -24px;\n  }\n"
    ]);
    IfoSteps_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function IfoSteps_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n"
    ]);
    IfoSteps_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
















var SmallStakePoolCard = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-3581eae9-0"
})(IfoSteps_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-3581eae9-1"
})(IfoSteps_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var IfoSteps_InlineLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-3581eae9-2"
})(IfoSteps_templateObject2());
var Step1 = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var credit = (0,hooks/* useIfoCredit */.cq)();
    var ceiling = (0,hooks/* useIfoCeiling */.dd)();
    var creditDollarValue = (0,useBUSDPrice/* useBUSDCakeAmount */.Tx)((0,formatBalance/* getBalanceNumber */.mW)(credit));
    var weeksDisplay = (0,helpers/* getICakeWeekDisplay */.XW)(ceiling);
    var ref = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("The number of iSHDW equals the locked staking amount if the staking duration is longer than %weeks% weeks. If the staking duration is less than %weeks% weeks, it will linearly decrease based on the staking duration.", {
                    weeks: weeksDisplay
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IfoSteps_InlineLink, {
                external: true,
                href: "https://shadow-11.gitbook.io/shadowswap/products/ifo-initial-farm-offering",
                children: t("Learn more about iSHDW")
            })
        ]
    }), {}), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                as: "h4",
                color: "secondary",
                mb: "16px",
                children: t("Lock SHDW in the SHDW pool")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mb: "4px",
                        color: "textSubtle",
                        small: true,
                        children: t("The maximum amount of CORE you can commit to the Public Sale equals the number of your iSHDW. Lock more SHDW for longer durations to increase the maximum WCORE you can commit to the sale.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                        as: "span",
                        fontWeight: 700,
                        ref: targetRef,
                        color: "textSubtle",
                        small: true,
                        children: t("How does the number of iSHDW calculated?")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mt: "4px",
                        color: "textSubtle",
                        small: true,
                        children: t("Missed this IFO? You will enjoy the same amount of iSHDW for future IFOs if your locked-staking position is not unlocked.")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallStakePoolCard, {
                borderRadius: "default",
                p: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Flex/* FlexGap */.O, {
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "16px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoRound/* default */.Z, {
                                style: {
                                    alignSelf: "flex-start"
                                },
                                width: 32,
                                height: 32
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                ml: "16px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        bold: true,
                                        fontSize: "12px",
                                        textTransform: "uppercase",
                                        color: "secondary",
                                        children: t("Your max WCORE entry")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                        fontSize: "20px",
                                        bold: true,
                                        decimals: 5,
                                        value: (0,formatBalance/* getBalanceNumber */.mW)(credit)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "12px",
                                        color: "textSubtle",
                                        children: creditDollarValue !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                            value: creditDollarValue,
                                            fontSize: "12px",
                                            color: "textSubtle",
                                            decimals: 2,
                                            prefix: "~",
                                            unit: " USD"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            mt: "1px",
                                            height: 16,
                                            width: 64
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var Step2 = function(param) {
    var isLive = param.isLive, isCommitted = param.isCommitted;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                as: "h4",
                color: "secondary",
                mb: "16px",
                children: t("Commit WCORE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                color: "textSubtle",
                small: true,
                children: [
                    t("Please note that SHDW in the fixed-term staking positions will remain locked and can not be used for committing to IFO sales. You will need a separate amount of WCORE in your wallet balance to commit to the IFO sales."),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            isLive && !isCommitted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                as: "a",
                href: "#current-ifo",
                mt: "16px",
                children: t("Commit WCORE")
            })
        ]
    });
};
var IfoSteps = function(param) {
    var isCommitted = param.isCommitted, hasClaimed = param.hasClaimed, isLive = param.isLive, ifoCurrencyAddress = param.ifoCurrencyAddress;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var t = (0,src/* useTranslation */.$G)().t;
    var balance = (0,useTokenBalance/* default */.ZP)(ifoCurrencyAddress).balance;
    var stepsValidationStatus = [
        balance.isGreaterThan(0),
        isCommitted,
        hasClaimed
    ];
    var getStatusProp = function(index) {
        var arePreviousValid = index === 0 ? true : every_default()(stepsValidationStatus.slice(0, index), Boolean);
        if (stepsValidationStatus[index]) {
            return arePreviousValid ? "past" : "future";
        }
        return arePreviousValid ? "current" : "future";
    };
    var renderCardBody = function(step) {
        var renderAccountStatus = function() {
            if (!account) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {});
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                as: NextLink/* NextLinkFromReactRouter */.a,
                to: "/swap/".concat(account.toLowerCase()),
                children: t("Convert CORE to WCORE")
            });
        };
        switch(step){
            case 0:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            as: "h4",
                            color: "secondary",
                            mb: "16px",
                            children: t("Convert CORE to WCORE")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "textSubtle",
                            small: true,
                            mb: "16px",
                            children: t("You’ll need WCORE to take part in this IFO!, Swap CORE to WCORE on the swap page.")
                        }),
                        renderAccountStatus()
                    ]
                });
            case 1:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Step1, {});
            case 2:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Step2, {
                    isLive: isLive,
                    isCommitted: isCommitted
                });
            case 3:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            as: "h4",
                            color: "secondary",
                            mb: "16px",
                            children: t("Claim your tokens")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "textSubtle",
                            small: true,
                            children: t("After the IFO sales finish, you can claim any IFO tokens that you bought, and any unspent WCORE tokens will be returned to your wallet.")
                        })
                    ]
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                id: "ifo-how-to",
                as: "h2",
                scale: "xl",
                color: "secondary",
                mb: "24px",
                textAlign: "center",
                children: t("How to Take Part in the Public Sale")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stepper/* default */.Z, {
                children: stepsValidationStatus.map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Step/* Step */.h, {
                        index: index,
                        statusFirstPart: getStatusProp(index),
                        statusSecondPart: getStatusProp(index + 1),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                            children: renderCardBody(index)
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var components_IfoSteps = (IfoSteps);

;// CONCATENATED MODULE: ./src/views/Ifos/CurrentIfo.tsx







var CurrentIfo = function(param) {
    var activeIfo = param.activeIfo;
    var publicIfoData = (0,useGetPublicIfoData/* default */.Z)(activeIfo);
    var walletIfoData = (0,useGetWalletIfoData/* default */.Z)(activeIfo);
    var poolBasic = walletIfoData.poolBasic, poolUnlimited = walletIfoData.poolUnlimited;
    var isCommitted = (0,react.useMemo)(function() {
        return poolBasic.amountTokenCommittedInLP.isGreaterThan(0) || poolUnlimited.amountTokenCommittedInLP.isGreaterThan(0);
    }, [
        poolBasic.amountTokenCommittedInLP,
        poolUnlimited.amountTokenCommittedInLP
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IfoContainer, {
        ifoSection: /*#__PURE__*/ (0,jsx_runtime.jsx)(IfoFoldableCard/* IfoCurrentCard */.KK, {
            ifo: activeIfo,
            publicIfoData: publicIfoData,
            walletIfoData: walletIfoData
        }),
        ifoSteps: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IfoSteps, {
            isLive: publicIfoData.status === "live",
            hasClaimed: poolBasic.hasClaimed || poolUnlimited.hasClaimed,
            isCommitted: isCommitted,
            ifoCurrencyAddress: activeIfo.currency.address
        })
    });
};
/* harmony default export */ var Ifos_CurrentIfo = (CurrentIfo);

// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 5 modules
var tokens_src = __webpack_require__(40370);
// EXTERNAL MODULE: ./src/views/Ifos/components/IfoFoldableCard/IfoPoolCard/index.tsx + 25 modules
var IfoPoolCard = __webpack_require__(2397);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Help.tsx
var Help = __webpack_require__(95160);
;// CONCATENATED MODULE: ./src/views/Ifos/components/IfoFoldableCard/GenericIfoCard.tsx



var GenericIfoCard = function(param) {
    var title = param.title, variant = param.variant, action = param.action, content = param.content, tooltip = param.tooltip;
    var ref = (0,useTooltip/* default */.Z)(tooltip, {
        placement: "bottom"
    }), targetRef = ref.targetRef, tooltipMsg = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            tooltipVisible && tooltipMsg,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IfoCardStyles/* StyledCard */.rg, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                        p: "16px 24px",
                        variant: variant,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    fontSize: "20px",
                                    lineHeight: 1,
                                    children: title
                                }),
                                tooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: targetRef,
                                    style: {
                                        display: "flex",
                                        marginLeft: "8px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody/* default */.Z, {
                        p: "24px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                content,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    width: "100%",
                                    mt: "24px",
                                    children: action
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var IfoFoldableCard_GenericIfoCard = (GenericIfoCard);

;// CONCATENATED MODULE: ./src/views/Ifos/components/ComingSoonSection.tsx

function ComingSoonSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom-left-radius: 100% 40px;\n  border-bottom-right-radius: 100% 40px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center center;\n"
    ]);
    ComingSoonSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var CurveBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-395e9c87-0"
})(ComingSoonSection_templateObject());
function ComingSoonSection() {
    var t = (0,src/* useTranslation */.$G)().t;
    // const basicConfig = useMemo(
    //   () =>
    //     cardConfig(t, PoolIds.poolBasic, {
    //       version: 3.1,
    //     }),
    //   [t],
    // )
    var unlimitedConfig = (0,react.useMemo)(function() {
        return (0,IfoPoolCard/* cardConfig */.u)(t, constants_types/* PoolIds.poolUnlimited */.vr.poolUnlimited, {
            version: 3.1
        });
    }, [
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        background: "bubblegum",
        style: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurveBox, {
                height: [
                    100,
                    110,
                    160,
                    160
                ],
                backgroundImage: [
                    "url('/images/ifos/assets/ifo-coming-soon.png')",
                    "url('/images/ifos/assets/ifo-coming-soon.png')",
                    "url('/images/ifos/assets/ifo-coming-soon-desktop.png')",
                    "url('/images/ifos/assets/ifo-coming-soon-desktop.png')", 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IfoFoldableCard/* StyledCardBody */.ke, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IfoCardStyles/* CardsWrapper */.Y2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IfoFoldableCard_GenericIfoCard, {
                        title: unlimitedConfig === null || unlimitedConfig === void 0 ? void 0 : unlimitedConfig.title,
                        variant: unlimitedConfig === null || unlimitedConfig === void 0 ? void 0 : unlimitedConfig.variant,
                        tooltip: unlimitedConfig === null || unlimitedConfig === void 0 ? void 0 : unlimitedConfig.tooltip,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/shadowhome.png",
                                    alt: "Shadowswap",
                                    className: "Shadow-road",
                                    height: "88px",
                                    width: "88px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    textAlign: "center",
                                    fontWeight: 600,
                                    children: t("Follow our social channels to learn more about the next IFO.")
                                })
                            ]
                        }),
                        action: null
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/Ifos/SoonIfo.tsx





var SoonIfo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IfoContainer, {
        ifoSection: /*#__PURE__*/ (0,jsx_runtime.jsx)(ComingSoonSection, {}),
        ifoSteps: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IfoSteps, {
            isLive: false,
            hasClaimed: false,
            isCommitted: false,
            ifoCurrencyAddress: tokens_src/* bscTokens.cake.address */.ds.cake.address
        })
    });
};
/* harmony default export */ var Ifos_SoonIfo = (SoonIfo);

;// CONCATENATED MODULE: ./src/views/Ifos/Ifo.tsx




/**
 * Note: currently there should be only 1 active IFO at a time
 */ var activeIfo = constants/* ifosConfig.find */.Q2.find(function(ifo) {
    return ifo.isActive;
});
var Ifo = function() {
    return activeIfo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Ifos_CurrentIfo, {
        activeIfo: activeIfo
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Ifos_SoonIfo, {});
};
/* harmony default export */ var Ifos_Ifo = (Ifo);

;// CONCATENATED MODULE: ./src/pages/ifo/index.tsx



var CurrentIfoPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Ifos_Ifo, {});
};
CurrentIfoPage.Layout = Ifos/* IfoPageLayout */.t;
/* harmony default export */ var ifo = (CurrentIfoPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2298,1911,1314,1689,1495,4489,2074,7593,1324,2766,9774,2888,179], function() { return __webpack_exec__(92562); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);